<template>
    <div>
        <form class="form-horizontal" >

            <div class="panel panel-info">
                <!-- Default panel contents -->
                <div class="panel-heading">
                    <i class="fa fa-info-circle" aria-hidden="true"></i> DADOS BÁSICOS
                </div>

                <div class="panel-body">
                    <div class="form-group">

                        <div class="col-sm-3">
                            <label for="numero" :class="{'text-danger': !fibra.numero}" class="control-label">NÚMERO DA FIBRA</label>
                            <input id="numero" type="text" v-model.number="fibra.numero" class="form-control" >
                        </div>

                        <div class="col-sm-3">
                            <label for="nome" class="control-label">NOME DA FIBRA</label>
                            <input id="nome" disabled type="text" :value="(fibra.numero) ? 'FO-' + fibra.numero : null" class="form-control" >
                        </div>

                        <div class="col-sm-6">
                            <label for="portas" :class="{'text-danger': !fibra.porta_pon._id}" class="control-label">PORTA DA FIBRA</label>
                            <select id="portas" v-model="fibra.porta_pon._id" class="form-control" >
                                <option v-for="p of portas" :value="p._id" :key="p._id">{{ p.nome }}</option>
                            </select>
                        </div>

                    </div>
                </div>
            </div>

            <div class="form-group">
                <div class="col-sm-10">
                    <button type="button" v-if="user.level < 5" :disabled="! fibra.numero"
                            @click="save()"
                            class="btn btn-success">
                        <i class="fa fa-floppy-o" aria-hidden="true"></i> SALVAR FIBRA
                    </button>
                </div>
            </div>

            <br/>
            <list-cto-by-fibra :_id="_id" v-if="fibra._id"/>

        </form>
    </div>
</template>
<script>
import { ListCtoByFibra } from "../../../components/exports";
import { Fibra, PortaPon, CaixaCTO } from "../../../class/index";

export default {
    components: {
        ListCtoByFibra
    },
    data() {
        return {
            user: null,
            fibra: Fibra.create(),
            portas: [],
            ctos: []
        };
    },
    computed: {
        _id() {
            return this.$route.params.id;
        }
    },
    beforeMount() {
        this.user = this.$store.state.user;
        this.loadPortas();
        if (this._id) {
            this.loadPonto(this.$route.params.id);
            this.loadCTOS();
        }
    },
    beforeDestroy() {
        console.log("ponto off");
    },
    methods: {
        async loadPonto() {
            this.fibra = await Fibra.byID(this._id);
        },
        async loadPortas() {
            this.portas = await PortaPon.all();
        },
        loadCTOS() {
            CaixaCTO.byFibra(this._id)
                .then(rows => (this.ctos = rows))
                .catch(err => console.log(err));
        },
        save() {
            // eslint-disable-next-line no-undef
            swal.queue([
                {
                    title: "SALVAR",
                    confirmButtonText: "Salvar",
                    text: "Posso salvar a fibra?",
                    showCancelButton: true,
                    showLoaderOnConfirm: true,
                    preConfirm: () => {
                        return new Promise(resolve => {
                            Fibra.save(this.fibra)
                                .then(() => {
                                    resolve();
                                    this.$router.push({ path: "/fibras" });
                                })
                                .catch(err => {
                                    console.log(err);
                                    resolve();
                                });
                        });
                    }
                }
            ]);
        }
    }
};
</script>
